var _path, _path2, _g, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2 0 68.08 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.4524 20.3512C65.7736 16.385 63.369 12.8221 60.3119 9.75771C57.2548 6.70064 53.6846 4.29603 49.7184 2.61721C45.613 0.879733 41.2437 0 36.7497 0C30.7968 0 24.9539 1.59085 19.8515 4.59661C14.9543 7.48506 10.8562 11.5905 7.98242 16.495L8.47361 16.7809C14.3385 6.77395 25.1519 0.571827 36.7497 0.571827C54.8136 0.571827 69.5051 15.2634 69.5051 33.3272C69.5051 51.3251 54.9162 65.98 36.9403 66.0826V66.6545C41.3756 66.6325 45.6717 65.7527 49.7258 64.0373C53.6919 62.3584 57.2548 59.9538 60.3192 56.8967C63.3763 53.8397 65.7809 50.2694 67.4597 46.3033C69.1972 42.1979 70.0769 37.8285 70.0769 33.3346C70.0769 28.8406 69.1899 24.4639 67.4524 20.3512Z",
    fill: "#FF6363"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4163 33.3272C5.4163 28.5693 6.49397 23.8774 8.56134 19.6327C8.94989 18.8336 8.66398 17.8732 7.89421 17.4333L7.85756 17.4114C7.00715 16.9202 5.92214 17.2501 5.48961 18.1371C4.5439 20.0799 3.78146 22.1033 3.21696 24.178C2.41054 27.1471 2 30.2261 2 33.3272C2 38.0191 2.91639 42.5717 4.7345 46.8531C6.48664 50.9878 8.98655 54.7047 12.1829 57.9011C15.3719 61.0901 19.0888 63.5974 23.2309 65.3495C26.7572 66.8377 30.4667 67.7248 34.2789 67.996C35.2612 68.062 36.0897 67.2922 36.0897 66.3099V66.2732C36.0897 65.3788 35.4005 64.653 34.5061 64.5871C18.2677 63.4214 5.4163 49.8442 5.4163 33.3272Z",
    fill: "#FF6363"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_510_5996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.7494 61.8016C52.4752 61.8016 65.2235 49.0533 65.2235 33.3276C65.2235 17.6018 52.4752 4.85352 36.7494 4.85352C21.0237 4.85352 8.27539 17.6018 8.27539 33.3276C8.27539 49.0533 21.0237 61.8016 36.7494 61.8016Z",
    fill: "url(#paint0_linear_510_5996)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.543 61.086C51.7546 61.086 64.086 48.7546 64.086 33.543C64.086 18.3314 51.7546 6 36.543 6C21.3314 6 9 18.3314 9 33.543C9 48.7546 21.3314 61.086 36.543 61.086Z",
    fill: "#FF6363"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.665 40.6371L39.0002 22.9504C38.5801 22.2537 37.8136 21.8208 37 21.8208C36.1863 21.8208 35.4199 22.2537 34.9996 22.9505L24.3349 40.6371C23.9007 41.3573 23.8878 42.2596 24.3014 42.9919C24.715 43.7241 25.4943 44.179 26.3352 44.179H47.6647C48.5057 44.179 49.285 43.7241 49.6986 42.9918C50.1121 42.2595 50.0993 41.3572 49.665 40.6371ZM48.2247 42.1595C48.1108 42.361 47.8963 42.4863 47.6647 42.4863H26.3352C26.1037 42.4863 25.8891 42.3611 25.7753 42.1595C25.6615 41.9579 25.665 41.7095 25.7845 41.5113L36.4494 23.8246C36.565 23.6328 36.776 23.5136 37 23.5136C37.224 23.5136 37.435 23.6328 37.5506 23.8246L48.2154 41.5113C48.335 41.7095 48.3385 41.9579 48.2247 42.1595Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0078 28.7854C36.3639 28.7854 35.8613 29.1309 35.8613 29.7434C35.8613 31.6123 36.0812 34.2978 36.0812 36.1667C36.0812 36.6535 36.5053 36.8577 37.0078 36.8577C37.3847 36.8577 37.9187 36.6535 37.9187 36.1667C37.9187 34.2979 38.1385 31.6123 38.1385 29.7434C38.1385 29.131 37.6203 28.7854 37.0078 28.7854Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0238 37.9414C36.3328 37.9414 35.8145 38.4911 35.8145 39.1507C35.8145 39.7946 36.3327 40.36 37.0238 40.36C37.6677 40.36 38.2174 39.7946 38.2174 39.1507C38.2174 38.4911 37.6676 37.9414 37.0238 37.9414Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_510_5996",
    x: 0.275391,
    y: 0.853516,
    width: 96.9473,
    height: 96.948,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839653 0 0 0 0 0.839653 0 0 0 0 0.891667 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_510_5996"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_510_5996",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_510_5996",
    x1: 54.4732,
    y1: 55.6091,
    x2: 19.0231,
    y2: 11.0416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.4e-7,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.0699fcc9f456ed2b90747a7e2b709073.svg";
export { ForwardRef as ReactComponent };